import React from 'react'
import Header from '../components/homepage/Header'
import Banner from '../components/empower/Banner'
import List from '../components/empower/List'
import ClientLogo from '../components/empower/ClientLogo'
import ExtraFooter from '../components/homepage/ExtraFooter'
import Footer from '../components/homepage/Footer'
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Controller } from 'react-scrollmagic';
import { useLocation } from "react-router-dom"


const Index = (props: any) => {
    const theme = useTheme();
    const isMobileScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const location = useLocation()
    const params = new URLSearchParams(location.search);
    const category = params.get("category")
    const page = Number(params.get("page"))
    const anchor = Boolean(params.get("anchor"))
    return (
        <Controller>
            <div>
                <Header />
                <Banner />
                <List isMobileScreen={isMobileScreen} category={category} page={page} anchor={anchor} />
                <ClientLogo isMobileScreen={isMobileScreen} disableBackground={true} />
                <ExtraFooter />
                <Footer />
            </div>
        </Controller>
    )
}
export default Index;